import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  const testimonialSlider = document.getElementById("testimonial_slider");

  if (testimonialSlider) {
    const main = new Splide(testimonialSlider, {
      type: "fade",
      perPage: 1,
      perMove: 1,
      gap: 10,
      focus: "center",
      rewind: true,
      pagination: false,
      arrows: false,
      autoplay: true,
      interval: 3000,
      pauseOnHover: true,
      pauseOnFocus: true,
      resetProgress: false,
      breakpoints: {
        768: {
          focus: 0,
          gap: 0,
          trimSpace: true,
        },
      },
    });
    main.mount();
  }
});
